import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/esm/Button';

// import TextEffect from './textEffect';
// import Skills from '../../components/home/skills';
// import ParcursMain from '../../components/home/parcursMain';
// import CV from '../../components/home/cv';

import './home.css';
import '../../components/containers/text.css'

export default function Home({language}) {
    return (
        <div>
            <Container fluid className="principalImg text-center anta">
                <div className="homeContainer">
                    <Row>
                        <Col>
                            <p className="name">{`<`}Antonio-Cristian Crantea{`/>`}</p>
                            <p style={{fontSize: "3rem"}}>{`<`}M-am mutat!{`/>`}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button
                                variant="dark"
                                href="https://info-cu-toni.ro/"
                                className="homeButton px-4 py-2 rounded-pill shadow-sm"
                            >
                                Website Nou
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
        /*
        <div>
            <Container fluid className="principalImg text-center anta">
                <div className="homeContainer">
                    <Row>
                        <Col>
                            <p className="name">{`<`}Antonio-Cristian Crantea{`/>`}</p>
                            <TextEffect language={language} className="textEffect"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {language === "RO" && (
                                <Button
                                    variant="dark"
                                    href="/despre"
                                    className="homeButton px-4 py-2 rounded-pill shadow-sm"
                                >
                                    Află mai multe
                                </Button>
                            )}
                            {language === "UK" && (
                                <Button
                                    variant="dark"
                                    href="/about"
                                    className="homeButton px-4 py-2 rounded-pill shadow-sm"
                                >
                                    Find out more
                                </Button>
                            )}
                        </Col>
                    </Row>
                </div>
            </Container>
            <Skills language={language}/>
            <ParcursMain language={language}/>
            <CV language={language}/>
        </div>
        */
    )
}